import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=059e3bb4&scoped=true&"
import script from "./Searchbar.vue?vue&type=script&lang=ts&"
export * from "./Searchbar.vue?vue&type=script&lang=ts&"
import style0 from "./Searchbar.vue?vue&type=style&index=0&id=059e3bb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e3bb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
